import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import {
    Theme,
    createStyles,
    withStyles,
    WithStyles,
    Card,
    CardContent,
    Grid,
    Typography,
    Chip,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';
import {
    CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import {
    MyPATDialog,
    MyPATTextField,
    MyPATSelect,
    MyPATIconButton,
} from '../../../common';
import { MasterSubject, MasterClass } from '../../types/GoalManagementMasterBody';
import goalManagementService from '../../services/goalManagementService';
import { getCourseData, } from '../../actions/goalManagementActions';
import CourseSyllabusBody from '../../types/CourseSyllabusBody';


const styles = (theme: Theme) => createStyles({
    iconRoot: {
        fill: theme.palette.text.secondary,
        // opacity: 0.5,
        margin: 0,
    },
    textRight: {
        textAlign: 'right',
    },
    mb1x: {
        marginBottom: theme.spacing.unit,
    },
    cardContentRoot: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        },
    },
    ssChip: {
        marginTop: theme.spacing.unit / 2,
        marginRight: theme.spacing.unit,
        '& span': {
            fontWeight: 600,
            color: "#6d6d6d"
        },
        '&:hover': {
            backgroundColor: theme.palette.grey[300],
        },
        '&:focus': {
            backgroundColor: theme.palette.grey[300],
        }
    },
    activeChip: {
        background: theme.palette.primary.main,
        '& span': {
            fontWeight: 600,
            color: "#fff"
        },
        '&:hover': {
            background: theme.palette.primary.main,
        },
        '&:focus': {
            background: theme.palette.primary.main,
        }
    },
    chipDiv: {
        padding: theme.spacing.unit / 2,
    },
    addNew: {
        padding: theme.spacing.unit
    },
    saveClass: {
        paddingTop: theme.spacing.unit * 5,
        textAlign: "right",
    },
    hideChip: {
        display: 'none',
        pointerEvents: 'none',
    }
});

interface SubjectAddDialogDialogProps extends WithStyles<typeof styles> {
    isDialogOpen: boolean,
    dialogCloseHandler: () => void,
    masterClassList: MasterClass[],
    masterSubjectList: MasterSubject[],
    activeCourse: any,
    getCourseData: (courseId: string) => void,
    selectedList: any,
    groupId: string,
    courseData: CourseSyllabusBody[],
}

interface SubjectAddDialogDialogState {
    activeClass: boolean,
    activeSubject: boolean,
    selectedSubject: any,
    formData: {
        className?: string,
        subjectName?: string,
        classToAdd?: any[]
    },
    errForm: {
        className: { message: string },
        subjectName: { message: string },
        classToAdd: { message: string },
    },
    tempSubjectList: any[],
    removedSelectedList: string[],
    updateProps: boolean,
    tempMasterList: any[],
    localllyAddIds: any[],
    isForEdit: boolean,
    searchList: any[]
}

class SubjectAddDialogDialog extends Component<SubjectAddDialogDialogProps, SubjectAddDialogDialogState> {
    constructor(props: SubjectAddDialogDialogProps) {
        super(props);
        this.state = {
            activeSubject: false,
            activeClass: false,
            selectedSubject: {},
            tempSubjectList: [],
            formData: {
                className: '',
                subjectName: '',
                classToAdd: []
            },
            errForm: {
                className: { message: '' },
                subjectName: { message: '' },
                classToAdd: { message: '' }
            },
            removedSelectedList: [],
            updateProps: true,
            tempMasterList: [],
            localllyAddIds: [],
            isForEdit: false,
            searchList: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubjectSave = this.handleSubjectSave.bind(this);
        this.handleClassAdd = this.handleClassAdd.bind(this);
        this.handleClassSave = this.handleClassSave.bind(this);
        this.handleChip = this.handleChip.bind(this);
        this.handleGoalSelect = this.handleGoalSelect.bind(this);
        this.searchSubject = this.searchSubject.bind(this);
        this.dCloseHandler = this.dCloseHandler.bind(this);
    }

    resetForm = () => {
        const formData = {
            className: '',
            subjectName: '',
            classToAdd: []
        };
        return this.setState({ formData, activeClass: false, activeSubject: false, selectedSubject: {}, updateProps: true, tempSubjectList: [] });
    }

    componentWillUnmount() {
    }


    dCloseHandler() {
        this.resetForm();
        this.props.dialogCloseHandler();
    }


    static getDerivedStateFromProps(nextProps: any, prevState: any) {
        //Remeber about this it will help to maintain setstate
        if (prevState.updateProps) {

            let selectedSubject: any = {};
            let selectedList = nextProps.selectedList;
            let courseData = !_.isEmpty(nextProps.courseData) ? nextProps.courseData : [];
            let classData = selectedList["class"];
            let subjectData = selectedList["subject"];
            let masterId = "";
            let mClassList: any[] = [];
            let mSubjectList: any[] = [];
            let isForEdit = false;


            classData && classData.forEach((cD: any) => {
                masterId = _.isUndefined(cD["masterIDs"][0]) ? cD._id : cD["masterIDs"][0];
                if (!selectedSubject[masterId]) {

                    //In case of update we don't have to show that chip in UI
                    !_.isEmpty(subjectData[cD._id]) && subjectData[cD._id].map((sD: any) => {
                        sD["visible"] = false;
                    })

                    selectedSubject[masterId] = { class: [cD], subject: subjectData[cD._id] };
                }
                //This will help us to know wther it's for update
                isForEdit = true;
            });

            courseData && courseData.forEach((c: any) => {
                if (c.isLocal) {
                    if (c.type == 'class') {
                        mClassList.push(c);
                    } else if (c.type == 'subject') {
                        mSubjectList.push(c);
                    }
                }
            });

            let a: any = [];
            if (_.isArray(mClassList) && _.isArray(nextProps.masterClassList)) {
                a = [...mClassList, ...nextProps.masterClassList];
            }

            let b: any = [];
            if (_.isArray(nextProps.masterSubjectList) && _.isArray(mSubjectList)) {
                b = [...mSubjectList, ...nextProps.masterSubjectList];
            }


            return {
                selectedSubject: selectedSubject,
                activeSubject: prevState.activeSubject,
                activeClass: prevState.activeClass,
                tempMasterList: a,
                tempSubjectList: b,
                isForEdit: isForEdit,
                searchList: b,
            };
        }

        else
            return null;
    }


    initi() {
        let { masterSubjectList, selectedList } = this.props;
        if (!_.isEmpty(masterSubjectList)) {
            this.setState({ tempSubjectList: masterSubjectList });
        }
    }


    handleInputChange = (evt: any) => {
        let { formData }: any = this.state;
        const { name, value } = evt.target;
        formData[name] = value ? value.trimLeft() : '';
        return this.setState({ formData });
    }

    handleGoalSelect = () => {
        let { selectedSubject, removedSelectedList, localllyAddIds } = this.state;
        let { activeCourse, selectedList } = this.props;
        let indexSub = 0;

        if (activeCourse && !_.isEmpty(selectedSubject)) {
            let requestForm: any[] = [];
            let classFormData: any = {};
            let subjectForm: any = {};
            let classIndex: number;
            let classId: any[] = [];
            let classObjectId: string = "";
            let lastClassOrder = 0;
            let lastSubjectOrder = 0;
            let className = "";
            //We are doing this inside subject we want parent id and ancestors id of class so need to carry out following process
            Object.keys(selectedSubject).forEach((sS: any, i: number) => {
                Object.keys(selectedSubject[sS]).forEach((c: any, j: number) => {

                    //SELECTED CLASS 
                    if (c == 'class') {
                        classFormData = {};
                        let orderNo;
                        let sC = selectedSubject[sS][c][0];
                        classIndex = i;
                        className = sC.class ? sC.class : sC.name;

                        if (sC.orderNo) {
                            orderNo = sC.orderNo;
                            lastClassOrder = orderNo;
                        } else {
                            ++lastClassOrder;
                            orderNo = lastClassOrder;
                        }

                        let uniqueCode = !sC.uniqueCode ? goalManagementService.generateUniqueCode([], [{ orderNo: className }], className, 'class')
                            : sC.uniqueCode;


                        //Check whether its for update
                        //If it has master id then its for add new
                        if (sC["masterIDs"] && sC["masterIDs"].length > 0) {
                            classId = sC["masterIDs"];
                        } else {
                            //If its newely created class then make master id as empty
                            if (localllyAddIds.includes(sC._id)) {
                                classId = [];
                            }
                            //It's for updated pass _id as default;
                            else {
                                classId = [sC._id]
                            }
                        }

                        classFormData = {
                            name: className,
                            type: 'class',
                            courseId: _.get(activeCourse, '_id', ''),
                            courseItemID: activeCourse.courseItems[0].id,
                            masterIDs: classId,
                            isLocal: localllyAddIds.includes(sC._id) ? true : false,
                            orderNo: orderNo,
                            uniqueCode: uniqueCode
                        }

                        if ((sC["masterIDs"] && sC["masterIDs"].length > 0) || sC["isLocal"]) {
                            classFormData["_id"] = sC._id;
                        }
                        classObjectId = new Date().getTime() + '';
                        let a = { [classObjectId]: { class: classFormData, subject: [] } };
                        requestForm.push(a);
                    }


                    //SELECTED SUBJECT
                    if (c == 'subject') {
                        selectedSubject[sS][c].forEach((subject: any) => {
                            indexSub = indexSub + 1
                            subjectForm = {};
                            let orderNo;
                            let subjectId :any = [];
                            if (subject.orderNo) {
                                orderNo = subject.orderNo;
                                lastSubjectOrder = orderNo;
                            } else {
                                ++lastSubjectOrder;
                                orderNo = lastSubjectOrder;
                            }

                            let uniqueCode = !subject.uniqueCode ? goalManagementService.generateUniqueCode([], [{ orderNo: className }], orderNo, 'subject')
                                : subject.uniqueCode


                            //Check whether its for update
                            //If it has master id then its for add new
                            if (subject["masterIDs"] && subject["masterIDs"].length > 0) {
                                subjectId = subject["masterIDs"];
                            } else {
                                //If its newely created class then make master id is empty
                                if (localllyAddIds.includes(subject._id)) {
                                    subjectId = [];
                                }
                                //It's for updated pass _id as default;
                                else {
                                    subjectId = [subject._id]
                                }
                            }
                            let sequenceNumber = '';
                            if (requestForm[classIndex][classObjectId]) {
                            if(subject && subject.sequenceNumber && subject.sequenceNumber !== '') {
                                sequenceNumber = subject.sequenceNumber
                            } else {
                                sequenceNumber = (indexSub < 10) ? '0' + indexSub.toString() : indexSub.toString();
 
                            }
                            }

                            subjectForm = {
                                name: subject.name,
                                type: 'subject',
                                courseId: _.get(activeCourse, '_id', ''),
                                courseItemID: activeCourse.courseItems[0].id,
                                masterIDs: subjectId,
                                isLocal: localllyAddIds.includes(subject._id) ? true : false,
                                orderNo: orderNo,
                                uniqueCode: uniqueCode,
                                sequenceNumber: sequenceNumber
                            }

                            //IsLocal is checked for update 
                            //Since it should not create new entry in database 
                            if ((subject["masterIDs"] && subject["masterIDs"].length > 0) || subject["isLocal"]) {
                                subjectForm["_id"] = subject._id;
                                // subjectForm["isPresent"] = true;
                            }

                            if (requestForm[classIndex][classObjectId]) {
                                requestForm[classIndex][classObjectId]["subject"].push(subjectForm);
                            }
                        });
                        classIndex = -1;
                        classId = []
                        classObjectId = "";
                        lastSubjectOrder = 0;
                        className = "";
                    }


                })
            })

            if (!_.isEmpty(selectedList)) {
                let a = { removedIds: removedSelectedList }
                requestForm.push(a);
            }
            goalManagementService.saveCourseSyllabus(requestForm)
                .then((resObj) => {
                    this.resetForm();
                    this.props.dialogCloseHandler();
                    this.props.getCourseData(activeCourse._id);
                })

        }
    }

    handleChip = (classData: any, subjectData: any, evt: any) => {
        let { selectedSubject, removedSelectedList } = this.state;
        let { selectedList } = this.props;
        if (classData && subjectData) {
            let classId = classData._id;
            let subjectId = subjectData._id;
            let isPresent = false;

            if (!selectedSubject[classId]) {
                selectedSubject[classId] = { class: [classData], subject: [subjectData] };
            } else {

                //already present remove it since user clicked double time            
                selectedSubject[classId]["subject"].forEach((s: any, i: number) => {
                    // if (s._id == subjectId)
                    if ((s._id == subjectId) || s.masterIDs && s.masterIDs.includes(subjectId)) {
                        isPresent = true;
                        let sId = s._id;
                        selectedSubject[classId]["subject"].splice(i, 1);

                        if (!_.isEmpty(selectedList)) {
                            removedSelectedList.push(sId);
                        }

                        if (selectedSubject[classId]["subject"].length == 0) {
                            if (!_.isEmpty(selectedList)) {
                                if (selectedSubject[classId]["class"][0] && selectedSubject[classId]["class"][0]["_id"]) {
                                    let id = selectedSubject[classId]["class"][0]["_id"];
                                    removedSelectedList.push(id);
                                }
                            }
                            delete selectedSubject[classId];
                        }
                    }
                });

                if (!isPresent) {
                    selectedSubject[classId]["subject"].push(subjectData);
                }

            }
            this.setState({ selectedSubject, removedSelectedList, updateProps: false });

        }
    }



    handleClassSave = () => {
        let { formData, errForm, selectedSubject, localllyAddIds, tempMasterList, tempSubjectList } = this.state;
        let { activeCourse } = this.props;
        let className: any = formData["className"];
        let subjectName: any = formData["subjectName"];

        errForm["subjectName"]["message"] = subjectName && subjectName != '' ? '' : 'Enter subject Name';
        errForm["className"]["message"] = className && className != '' ? '' : 'Enter class Name';


        if (_.isEmpty(errForm["subjectName"]["message"]) && _.isEmpty(errForm["className"]["message"])) {

            let name = className.replace(/\s/g, '');

            let classId = `${name}${new Date().getTime()}`;

            name = subjectName.replace(/\s/g, '');
            let subjectId = `${name}${new Date().getTime()}`;

            let classObj = { class: className, _id: classId };
            tempMasterList.push(classObj);
            localllyAddIds.push(classId);

            let subjectObj = { name: subjectName, _id: subjectId, classes: [classId] };
            tempSubjectList.push(subjectObj);
            localllyAddIds.push(subjectId);


            formData = {
                className: '',
                subjectName: '',
                classToAdd: []
            }


            //push in selected array also
            selectedSubject[classId] = { class: [classObj], subject: [subjectObj] };


            this.setState({ tempMasterList, tempSubjectList, selectedSubject, activeClass: false, formData, updateProps: false, localllyAddIds });
        }

        this.setState({ errForm });
    }


    handleSubjectSave = () => {
        let { formData, errForm, tempSubjectList, localllyAddIds, selectedSubject, tempMasterList } = this.state;
        let classToAdd = formData["classToAdd"];
        let subjectName: any = formData["subjectName"];

        errForm["subjectName"]["message"] = subjectName && subjectName != '' ? '' : 'Enter subject Name';
        errForm["classToAdd"]["message"] = classToAdd && classToAdd.length > 0 ? '' : 'Select class to add';


        if (_.isEmpty(errForm["subjectName"]["message"]) && _.isEmpty(errForm["classToAdd"]["message"])) {
            classToAdd && classToAdd.forEach((c: any) => {
                let classData = _.find(tempMasterList, ['_id', c]);
                let className = classData && !_.isUndefined(classData.class) ? classData.class : classData.name;
                let name = subjectName.replace(/\s/g, '');
                let subjectId = `${name}${new Date().getTime()}`;
                let subjectObj = { name: subjectName, _id: subjectId, classes: [c] };
                tempSubjectList.push(subjectObj);

                localllyAddIds.push(subjectId);

                //Push in selected array
                if (_.isUndefined(selectedSubject[c])) {
                    selectedSubject[c] = { class: [{ _id: c, name: className }], subject: [subjectObj] };
                } else {
                    selectedSubject[c]["subject"].push(subjectObj);
                }
            })
            formData = {
                className: '',
                subjectName: '',
                classToAdd: []
            }


            this.setState({ tempSubjectList, activeSubject: false, selectedSubject, formData, updateProps: false, localllyAddIds });
        }
        this.setState({ errForm });

    }

    handleClassAdd = (evt: any) => {
        let { formData } = this.state;
        let { name, value, checked } = evt.target;
        if (formData && formData.classToAdd) {

            if (checked) {
                formData.classToAdd.push(value);
            } else {
                formData.classToAdd = formData.classToAdd.filter(c => c != value);
            }
            this.setState({ formData });
        }
    }


    searchSubject = (evt: any) => {
        let { value } = evt.target;
        let { tempSubjectList, updateProps, searchList } = this.state;

        let tempList : any = [];
        tempSubjectList = searchList;
        if (value) {
            tempSubjectList.forEach((subj: any) => {
                if (value && subj && subj.name && subj.name.toLowerCase().search(value.toLowerCase()) != -1) {
                    tempList.push(subj);
                }
            });
        } else {
            tempList = tempSubjectList;
        }

        this.setState({ tempSubjectList: tempList, updateProps: false });
    }

    render() {
        const {
            classes,
            isDialogOpen,
            dialogCloseHandler,
            masterClassList,
            masterSubjectList,
        } = this.props;

        const {
            formData,
            activeSubject,
            activeClass,
            errForm,
            selectedSubject,
            tempSubjectList,
            tempMasterList,
            isForEdit
        } = this.state;
        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        }

        let getChipActive = (classId: string, subjectId: string) => {
            let isPresent = false;
            let hasVisible = false;
            if (!_.isEmpty(selectedSubject)) {
                selectedSubject[classId] && selectedSubject[classId]["subject"] && selectedSubject[classId]["subject"].forEach((s: any) => {
                    //master id will be used for update case

                    isPresent = ((s._id == subjectId) || s.masterIDs && s.masterIDs.includes(subjectId)) ? true : isPresent;
                    hasVisible = isPresent && _.isEqual(s["visible"], false) ? true : hasVisible;
                })
            }
            return isPresent && hasVisible ? `${classes.hideChip}` : isPresent ? classes.activeChip : '';
        }


        return (
            <MyPATDialog
                dialogHeading="Add Subjects"
                dialogOpen={isDialogOpen}
                otherDialogProps={otherDialogProps}
                onDialogClose={this.dCloseHandler}
            >
                <Card>
                    <CardContent className={classes.cardContentRoot}>
                        <Grid container spacing={8} alignItems="center">
                            <Grid item xs={12} className={classes.mb1x}>
                                <MyPATTextField
                                    inputId="newTestType"
                                    name="newTestType"
                                    onChange={this.searchSubject}
                                    placeholder="Search Subject"
                                    fullWidthControl
                                >
                                </MyPATTextField>
                                <Grid item xs="auto">
                                    {
                                        _.map(tempMasterList, (classE, i) => {
                                            let tmpsublist = tempSubjectList.filter(subject => 
                                                {
                                                    if(_.isEmpty(subject.classes) || (!_.isUndefined(subject.classes) && subject.classes.includes(classE._id))){
                                                        if(getChipActive(classE._id,subject._id) != classes.hideChip){
                                                            return subject;
                                                        }
                                                    }
                                        });
                                            return (
                                                
                                                <Grid className={tmpsublist.length > 0?classes.chipDiv:""} key={`${classE._id}_${i}`} item xs="auto">
                                                    {tmpsublist.length > 0 ?
                                                    <Typography variant="body2" key={`${classE._id}_${i}`} align="left">Class {
                                                        _.isEmpty(classE.class) ? classE.name : classE.class
                                                    }</Typography> : ""}
                                                    {
                                                        _.map(tempSubjectList, (subject: any, j) => (
                                                            ( (!_.isEmpty(subject.classes) && !_.isUndefined(subject.classes)) && subject.classes.includes(classE._id))
                                                                ?
                                                                <Chip
                                                                    classes={{ root: classes.ssChip }}
                                                                    className={getChipActive(classE._id, subject._id)}
                                                                    clickable={true}
                                                                    key={`${classE._id}_${subject._id}`}
                                                                    label={subject.name}
                                                                    onClick={this.handleChip.bind(this, classE, subject)}
                                                                /> 
                                                                :
                                                                ''
                                                        ))
                                                    }

                                                </Grid>
                                            )
                                        })

                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                <Grid item className={classes.addNew} container>
                    <Grid item xs={12}>
                        {
                            !activeSubject && !activeClass
                                ?
                                <>
                                    <Button onClick={() => { this.setState({ activeClass: !activeClass }) }} color="primary">Add New Class</Button>
                                    <Button onClick={() => { this.setState({ activeSubject: !activeSubject }) }} color="primary">Add New Subject</Button>
                                </>
                                :
                                ''
                        }

                        {
                            activeClass ?
                                <Card>
                                    <CardContent className={classes.cardContentRoot}>
                                        <Grid container>
                                            <Grid item xs={6} className={classes.mb1x}>
                                                <Typography variant="body1" gutterBottom>Create Class</Typography>
                                                <MyPATTextField
                                                    inputId="className"
                                                    name="className"
                                                    placeholder="Type Class Name"
                                                    value={formData.className || ''}
                                                    error={errForm.className.message != '' ? true : false}
                                                    errorText={errForm.className.message}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Grid>
                                            <Grid item xs={6} className={classes.textRight}>
                                                <MyPATIconButton buttonVariant="flat" onClick={() => { this.setState({ activeClass: false }) }}>
                                                    <CloseIcon classes={{ root: classes.iconRoot }} />
                                                </MyPATIconButton>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={8} className={classes.mb1x}>
                                                <Typography variant="body1" gutterBottom>Create Subject</Typography>
                                                <MyPATTextField
                                                    inputId="subjectName"
                                                    name="subjectName"
                                                    placeholder="Type Subject Name"
                                                    value={formData.subjectName || ''}
                                                    error={errForm.subjectName.message != '' ? true : false}
                                                    errorText={errForm.subjectName.message}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Grid>
                                            <Grid item xs={4} className={`${classes.mb1x} ${classes.saveClass}`}>
                                                <Button onClick={this.handleClassSave} color="primary">Save Class</Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                : ''
                        }
                        {
                            activeSubject ?
                                <Card>
                                    <CardContent className={classes.cardContentRoot}>
                                        <Grid container>
                                            <Grid item xs={6} className={classes.mb1x}>
                                                <Typography variant="body1" gutterBottom>Create Subjects</Typography>
                                                <MyPATTextField
                                                    inputId="subjectName"
                                                    name="subjectName"
                                                    placeholder="Type Subject Name"
                                                    value={formData.subjectName || ''}
                                                    error={errForm.subjectName.message != '' ? true : false}
                                                    errorText={errForm.subjectName.message}
                                                    onChange={this.handleInputChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6} className={classes.textRight}>
                                                <MyPATIconButton buttonVariant="flat" onClick={() => { this.setState({ activeSubject: false }) }}>
                                                    <CloseIcon classes={{ root: classes.iconRoot }} />
                                                </MyPATIconButton>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={8}>
                                                <Typography variant="body1">Select Class to add to</Typography>
                                                <FormGroup
                                                    onChange={this.handleClassAdd}
                                                    row>
                                                    {
                                                        _.map(tempMasterList, (classN, i) => (
                                                            <FormControlLabel
                                                                key={`${classN._id}_${i}`}
                                                                control={<Checkbox color="primary" />}
                                                                label={
                                                                    _.isEmpty(classN.class) ? classN.name : classN.class
                                                                }
                                                                value={classN._id}
                                                            />
                                                        ))
                                                    }

                                                </FormGroup>
                                                <Typography variant="caption" color="error">{errForm.classToAdd.message}</Typography>
                                            </Grid>
                                            <Grid item xs={4} className={`${classes.mb1x} ${classes.saveClass}`}>
                                                <Button onClick={this.handleSubjectSave} color="primary">Save Subject</Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                : ''
                        }
                    </Grid>
                    <Grid item xs={12} className={classes.saveClass}>
                        <Button onClick={this.handleGoalSelect} variant="contained" color="primary">Add to Goal</Button>
                    </Grid>
                </Grid>
            </MyPATDialog>
        )
    }
}


const mapStateToProps = (state: any) => ({
    masterClassList: _.get(state, 'goalManagement.goalManagement.classList', []),
    masterSubjectList: _.get(state, 'goalManagement.goalManagement.subjectList', []),
    courseData: _.get(state, 'goalManagement.goalManagement.courseData', [])
});


const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    getCourseData,
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SubjectAddDialogDialog));